import * as PIXI from 'pixi.js';
import { Frame } from '@orbital/slot-lib';
import PressButton from './PressButton.js';
import ToggleButton from './ToggleButton.js';
import SwitchButton from './SwitchButton.js';
import MouseOverSprite from './MouseOverSprite.js';
import { GameConfigs } from '../lib/globals/GameConfigs.js';
import SpinButton from './SpinButton.js';
import ActionButton from './ActionButton.js';
import Button from './Button.js';

class VisualComponent extends Frame {
	constructor(obj) {
		super(obj, PIXI, GameConfigs, VisualComponent);

		this.initComponents();
		this.attachControllers();
	}

	initComponents() {
		if (!Array.isArray(this.config.components)) return;

		for (let i = 0; i < this.config.components.length; i++) {
			const element = this.config.components[i];
			switch (element.type) {
				case 'Sprite':
					this.createSprite(element);
					break;
				case 'SwitchButton':
					this.createSwitchButton(element);
					break;
				case 'ActionButton':
					this.createActionButton(element);
					break;
				case 'PressButton':
					this.createPressButton(element);
					break;
				case 'SpinButton':
					this.createSpinButton(element);
					break;
				case 'ToggleButton':
					this.createToggleButton(element);
					break;
				case 'MouseOverSprite':
					this.createMouseOverSprite(element);
					break;
				case 'AnimatedSprite':
					this.createAnimatedSprite(element);
					break;
				case 'Text':
					this.createText(element);
					break;
				case 'CustomText':
					this.createCustomText(element);
					break;
				case 'Button':
					this.createButton(element);
					break;
				case 'VisualComponent':
					this.createVisualComponent(element);
					break;

				default:
					break;
			}
		}
	}

	attachControllers() {
		if (
			this.config.controllers !== undefined &&
			Array.isArray(this.config.controllers)
		) {
			for (let i = 0; i < this.config.controllers.length; i++) {
				const element = this.config.controllers[i];
				const controller = new element.Controller(this, element.config);
				this[element.name] = controller;
			}
		}
	}

	createButton(obj) {
		obj.handler = this.clickHandler.bind(this);
		const button = new Button(obj);
		this.addComponent(obj, button);
	}

	createCustomText(obj) {
		const text = new PIXI.BitmapText(
			window.lm[obj.text].value,
			window.lm[obj.text].config
		);
		text.name = obj.name;
		if (obj.anchor) {
			text.anchor.x = obj.anchor.x;
			text.anchor.y = obj.anchor.y;
		}
		this.addComponent(obj, text);
	}
	createText(obj) {
		const text = new PIXI.Text(
			window.lm[obj.text].value,
			window.lm[obj.text].config
		);
		text.name = obj.name;
		this.addComponent(obj, text);
	}

	createSwitchButton(obj) {
		obj.handler = this.clickHandler.bind(this);
		const switchButton = new SwitchButton(obj);
		switchButton.name = obj.name;
		this.addComponent(obj, switchButton);
	}

	createActionButton(obj) {
		obj.handler = this.clickHandler.bind(this);
		const actionButton = new ActionButton(obj);
		actionButton.name = obj.name;
		this.addComponent(obj, actionButton);
	}

	createPressButton(obj) {
		obj.handler = this.clickHandler.bind(this);
		const pressButton = new PressButton(obj);
		pressButton.name = obj.name;
		this.addComponent(obj, pressButton);
	}

	createSpinButton(obj) {
		obj.handler = this.clickHandler.bind(this);
		const spinButton = new SpinButton(obj);
		spinButton.name = obj.name;
		this.addComponent(obj, spinButton);
	}

	createToggleButton(obj) {
		obj.handler = this.clickHandler.bind(this);
		const toggleButton = new ToggleButton(obj);
		toggleButton.name = obj.name;
		this.addComponent(obj, toggleButton);
	}

	createMouseOverSprite(obj) {
		const mouseOver = new MouseOverSprite(obj);
		mouseOver.name = obj.name;
		if (obj.config) {
			mouseOver.config = obj.config;
		}
		this.addComponent(obj, mouseOver);
	}

	createSprite(obj) {
		const sp = obj.img
			? new PIXI.Sprite(PIXI.Texture.from(obj.img))
			: new PIXI.Sprite(PIXI.Texture.EMPTY);

		if (obj.alpha) {
			sp.alpha = obj.alpha;
		}
		if (obj.anchor) {
			sp.anchor.set(obj.anchor.x, obj.anchor.y);
		}
		sp.name = obj.name;
		this.addComponent(obj, sp);
	}
}

export default VisualComponent;
